exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".batch-set .pointer[data-v-1211a86f]{cursor:pointer}.batch-set .table .attr-img[data-v-1211a86f]{width:40px;max-height:40px;-o-object-fit:contain;object-fit:contain}.batch-set .avatar-uploader[data-v-1211a86f]{display:inline-block}.batch-set .avatar-uploader .el-upload[data-v-1211a86f]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.batch-set .avatar-uploader .el-upload[data-v-1211a86f]:hover{border-color:#409eff}.batch-set .avatar-uploader .cameraIconfont[data-v-1211a86f]{font-size:28px;color:#8c939d;width:40px;height:40px;line-height:40px;text-align:center;display:block}", ""]);

// exports
